import React from 'react';
import './ConfirmDeletePopup.css';
import CustomModal from '../../global/CustomModal/CustomModal';
import CustomButton from '../../global/Button/CustomButton';
const ConfirmDeletePopup = ({ isOpen, onClose, onConfirm, text, title, confirmtext, buttonColor, className }) => {


  const titleToShow = title || "Confirm Delete";
  const textToShow = text || "Are you sure you want to delete this item?";
  const confirmText = confirmtext || "Delete";
  return (
    <CustomModal
      visible={isOpen}
      onClose={onClose}
      title={titleToShow}
      width={428}
    >
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column"
      }}>
        <div style={{
          marginTop: "20px"
        }}>
          <p style={{
            fontSize: "16px",
          }} className="confirm-modal-message">{textToShow}</p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            width: "100%",
            marginTop: "20px",
          }}
        >
          <CustomButton
           className="!w-1/2"
            onClick={onConfirm}
            variant="primary"
          >
            {confirmText}
          </CustomButton>
          <CustomButton
           className="!w-1/2"
            onClick={onClose}
            variant="outlined"
          >
            Cancel
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};
export default ConfirmDeletePopup;